import {styled} from '../../styled-components';

// TODO: remove font properties after Typography components are added.
export const TableTitleStyle = styled.div`
    width: 100%;
    height: ${props => props.theme.spacing.units(10)};
    display: flex;
    padding: 0 ${props => props.theme.spacing.units(5)};
    background: ${props => props.theme.color.primary.main};
    color: white;
    align-items: center;
    font-size: ${props => props.theme.typography.pxToRem(18)};
    font-family: ${props => props.theme.typography.fontFamily};
`;
